/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Assistant_Previous_AttemptInputs */



/**
* | output |
* | --- |
* | "Previous attempt ({count} messages)" |
*
* @param {Assistant_Previous_AttemptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_previous_attempt = /** @type {((inputs: Assistant_Previous_AttemptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Previous_AttemptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tentative précédente (${i?.count} messages)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Vorheriger Versuch (${i?.count}-Nachrichten)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tentativo precedente (messaggi ${i?.count})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предыдущая попытка (сообщения ${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Intento anterior (${i?.count} mensajes)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`上次尝试（${i?.count} 消息）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`前回の試行（${i?.count} メッセージ）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पिछला प्रयास (${i?.count} संदेश)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tentativa anterior (${i?.count} mensagens)`)
	return /** @type {LocalizedString} */ (`Previous attempt (${i?.count} messages)`)
});